import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

export const IRRIGATION_TIME_ZONE = "Europe/Madrid";

export const irrigationStartSlots = Array.from({ length: 23 }, (_, index) => {
  const minutes = (6 * 60) + (index * 30);
  return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
});

const madridDate = (value) => formatInTimeZone(new Date(value), IRRIGATION_TIME_ZONE, "yyyy-MM-dd");

export const slotStart = (selectedDate, time) =>
  fromZonedTime(`${madridDate(selectedDate)}T${time}:00`, IRRIGATION_TIME_ZONE);

export const eventDurationMinutes = (event) => {
  const duration = Number(event.durationMinutes ?? event.duration);
  if (Number.isFinite(duration)) return duration;
  return Math.round((new Date(event.end).getTime() - new Date(event.start).getTime()) / 60000);
};

export const queueEventId = (event) => event?.event_id ?? event?.id ?? null;

export const slotIsAvailable = ({ selectedDate, time, durationMinutes, events, ignoreEventId }) => {
  const start = slotStart(selectedDate, time);
  const end = new Date(start.getTime() + (Number(durationMinutes) * 60 * 1000));
  return !events.some((event) => {
    if (event.type !== "queue" || String(queueEventId(event)) === String(ignoreEventId ?? "")) return false;
    const eventStart = new Date(event.start);
    const eventEnd = event.end ? new Date(event.end) : new Date(eventStart.getTime() + eventDurationMinutes(event) * 60 * 1000);
    return start < eventEnd && end > eventStart;
  });
};

export const timeForMadrid = (value) => formatInTimeZone(new Date(value), IRRIGATION_TIME_ZONE, "HH:mm");
